export {PromptInputFooter, type PromptInputFooterProps} from './PromptInputFooter';
